import React from 'react';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router';
import styled from 'styled-components';

import { FieldBlock, FieldSwitch } from '../../ui';

const UsernameEmailSwitchWrapper = styled.div`
  padding-top: 50px;
`;

const UsernameSettingsForm = () => {
  const intl = useIntl();

  return (
    <UsernameEmailSwitchWrapper>
      <FieldBlock>
        <FieldSwitch
          name="is_username_email"
          label={intl.formatMessage({
            id: 'configuration-page.username.username-validation.tests.username-email'
          })}
        />
      </FieldBlock>
    </UsernameEmailSwitchWrapper>
  );
};

export default withRouter(UsernameSettingsForm);
